import { Component } from 'react';

import styles from './ErrorBoundary.module.scss';

/**
 * ErrorBoundary
 * - 하위 트리 렌더링 중 발생한 자바스크립트 에러를 잡아
 *   화면 전체가 흰 화면이 되는 것을 방지한다.
 * - 에러 발생 시 안내 메시지와 다시 시도 버튼을 노출한다.
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.handleRetry = this.handleRetry.bind(this);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // 운영 환경에서는 로깅 서비스로 전송하도록 확장 가능
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  handleRetry() {
    this.setState({ hasError: false });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className={styles.container}>
          <div className={styles.box}>
            <div className={styles.title}>일시적인 오류가 발생했습니다.</div>
            <div className={styles.message}>
              화면을 불러오는 중 문제가 발생했습니다. 다시 시도해 주세요.
            </div>
            <button type="button" className={styles.retryButton} onClick={this.handleRetry}>
              다시 시도
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
